<script lang="ts">import { onDestroy } from 'svelte';
import FlyoutToggle from '../../../shared/FlyoutToggle/FlyoutToggle.svelte';
import Link from '../../../shared/Link/Link.svelte';
import LinkList from '../../../shared/LinkList/LinkList.svelte';
import Dropdown from '../Dropdown/Dropdown.svelte';
import { getLoggedIn, getCartCount } from '../../../../../js-v2/stores/user-state-stores';
import { getComponentType } from '../../../../../js-v2/componentUtils';
import { filterNavItems } from '../../../../../js-v2/navItemFilters';
import { activeDropdownStore } from '../../../../../js-v2/stores/desktop-nav-stores';
import { hoverWithDelay } from '../../../../../js-v2/hoverWithDelay';
import { TIMEOUT_ENTER_DURATION, TIMEOUT_LEAVE_DURATION } from '../../../../../js-v2/constants';
const { navItems = [], enableLinkHoverOpacity = false, enableInactiveState = false, shouldRenderFlyout = false, } = $props();
const cartCountStore = getCartCount();
const loggedInStore = getLoggedIn();
let activeId = $state('');
let activeType = $state('');
const dropdownStoreSub = activeDropdownStore.subscribe((state) => {
    if (state?.id) {
        activeId = state.id;
        activeType = 'dropdown';
    }
    else {
        if (activeType !== 'link') {
            activeId = '';
            activeType = '';
        }
    }
});
const filteredNavItems = $derived(filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
}));
function handleMouseOver(id, type) {
    activeId = id;
    activeType = type;
}
function handleMouseOut(id) {
    if (activeId === id) {
        activeId = '';
        activeType = '';
    }
}
onDestroy(dropdownStoreSub);
</script>

<ul class="NavList">
  {#each filteredNavItems as item}
    {#if ['category', 'imageListCategory'].includes(getComponentType(item.componentName))}
      {#if shouldRenderFlyout}
        <li
          class:inactive={enableInactiveState && activeId !== '' && activeId !== item.contentfulEntryId}
          use:hoverWithDelay={[
            () => handleMouseOver(item.contentfulEntryId, 'flyout'),
            () => handleMouseOut(item.contentfulEntryId),
            TIMEOUT_ENTER_DURATION,
            TIMEOUT_LEAVE_DURATION,
          ]}
        >
          <FlyoutToggle id={item.contentfulEntryId} title={item.props.title} alignment="right">
            <LinkList
              id={item.contentfulEntryId}
              title={item.props.title}
              excludeTitleOnDesktop={true}
              navItems={item.props.primaryNavItems}
            />
          </FlyoutToggle>
        </li>
      {:else}
        <li
          class:inactive={enableInactiveState && activeId !== '' && activeId !== item.contentfulEntryId}
          use:hoverWithDelay={[
            () => handleMouseOver(item.contentfulEntryId, 'dropdown'),
            () => handleMouseOut(item.contentfulEntryId),
            TIMEOUT_ENTER_DURATION,
            TIMEOUT_LEAVE_DURATION,
          ]}
        >
          <Dropdown {item} />
        </li>
      {/if}
    {:else if getComponentType(item.componentName) === 'link'}
      <li
        class:inactive={enableInactiveState && activeId !== '' && activeId !== item.contentfulEntryId}
        use:hoverWithDelay={[
          () => handleMouseOver(item.contentfulEntryId, 'link'),
          () => handleMouseOut(item.contentfulEntryId),
          TIMEOUT_ENTER_DURATION,
          TIMEOUT_LEAVE_DURATION,
        ]}
      >
        <Link
          linkCustomCssClass="nav-list-link"
          id={item.contentfulEntryId}
          title={item.props.title}
          url={item.props.url}
          linkStyle={item.props.linkStyle}
          enableHoverOpacity={enableLinkHoverOpacity}
          openInNewTab={item.props.openInNewTab}
        />
      </li>
    {/if}
  {/each}
</ul>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.NavList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
}
.NavList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.NavList > li::before {
  display: none;
}
.NavList > li :global(:last-child) {
  margin: 0;
}
.NavList li {
  transition: opacity 250ms;
}
.NavList li.inactive {
  opacity: 43%;
}</style>
